import { render, staticRenderFns } from "./NewOdd.vue?vue&type=template&id=ee0b00c0&"
import script from "./NewOdd.vue?vue&type=script&lang=js&"
export * from "./NewOdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports